export default __webpack_public_path__ + "static/media/LiveTV.14d76a35.svg";